<template>
  <div class="u-flex u-around" :style="{width: $device.isMobile ? viewportWidth*7 + 'px' : viewportWidth*5 + 'px'}" >
    <div v-for="logo in logos" class="u-w1of12">
      <div class="u-box-1by1">
        <app-image :id="logo.id" :src="logo.url" class="u-marg-b-lg u-fit-contain" />
      </div>
    </div>
  </div>
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'
import AppImage from '@/components/common/AppImage'

export default {
  mixins: [Object3d],

  components: {
    AppImage
  },

  props: {
    logos: {
      type: Array,
      default: () => {return []}
    },
    viewportWidth: {
      type: Number,
      default: 0
    }
  }
}
</script>